// extracted by mini-css-extract-plugin
export var upcomingEvent = "upcoming-event-module--upcoming-event--tfbGK";
export var upcomingEventImage = "upcoming-event-module--upcoming-event-image--ITDvr";
export var upcomingEventTitle = "upcoming-event-module--upcoming-event-title--fTPRI";
export var upcomingEventWrapper = "upcoming-event-module--upcoming-event-wrapper--ACDHS";